import { FC, Fragment } from 'react';
import Link from 'next/link';
import BookCardRating from '../book-card-rating/BookCardRating';
import ImgFullLabel from '../img-full-label/ImgFullLabel';
import { getAuthorFullName } from '@/helpers/helpers';
import { IAuthorBook, IAuthorBaseData } from '@/interfaces/authorDetail.interface';
import { parseISO, format } from 'date-fns';
import { getTruncatedTxt } from '@/helpers/helpers';
import { hideImgOnError } from '@/helpers/helpers';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import styles from './BookCardItem.module.scss';

interface IBookCardItemAuthor {
  authorAlias: string | undefined;
  createdAt: string;
  alias: string;
  author: IAuthorBaseData;
  book: IAuthorBook;
  rating: number;
  isAuthorLink?: boolean;
}

const BookCardItemAuthor: FC<IBookCardItemAuthor> = ({ book, authorAlias, createdAt, alias, author, rating, isAuthorLink }) => {
  const { title, description, external_id, genres } = book;

  const authorFullName = getAuthorFullName(author.first_name, author.middle_name, author.last_name);
  const bookFullAlias = `/authors/${authorAlias}/${alias}${book.allow_full_free === 1 && book.type === 'book' ? '/read' : ''}`;

  return (
    <div className={book.type === 'audio_book' ? `${styles.bookCard} ${styles.bookCard_audio}` : `${styles.bookCard}`}>
      <div className={styles.bookCard__wrap}>
        <div className={styles.bookCard__image}>
          <Link prefetch={false} className={styles.bookCard__imageLink} href={bookFullAlias}>
            <img src={`${DEV_ABSOLUTE_URL}/covers/${external_id}.jpg`} alt={title} onError={hideImgOnError} width="76" height="110" />
            <span className={styles.bookCard__imageLabel}>{book.type === 'audio_book' ? 'аудио' : 'текст'}</span>
            {book.allow_full_free > 0 && <ImgFullLabel />}
          </Link>
        </div>

        <div className={styles.bookCard__desc}>
          <div className={styles.bookCard__titleWrap}>
            <Link prefetch={false} className={styles.bookCard__title} href={bookFullAlias}>
              {title}
            </Link>
            {!!createdAt && createdAt!.length > 0 && (
              <div className={styles.bookCard__addDate}>
                <time dateTime={createdAt}>{format(parseISO(createdAt!), 'dd.MM.yyyy HH:mm')}</time>
              </div>
            )}
          </div>

          <div className={`${styles.bookCard__link} ${styles.bookCard__link_noHover}`}>
            {isAuthorLink ? (
              <Link prefetch={false} href={`/authors/${authorAlias}`}>
                {authorFullName}
              </Link>
            ) : (
              authorFullName
            )}
          </div>

          {genres &&
            genres.length > 0 &&
            genres.map((item, i) => (
              <Fragment key={item.id}>
                <Link prefetch={false} href={`/genres/${item.alias}`} className={`${styles.bookCard__link} ${styles.bookCard__link_inline}`}>
                  {item.title}
                </Link>
                {Number(i) < genres.length - 1 ? ', ' : ''}
              </Fragment>
            ))}

          <div className={styles.bookCard__rating}>
            <BookCardRating rating={rating} />
          </div>

          <div className={styles.bookCard__txt}>{getTruncatedTxt(description, 140)}</div>
        </div>
      </div>
      <div className={`${styles.bookCard__txt} ${styles.bookCard__txt_bottom}`}>{getTruncatedTxt(description, 140)}</div>
    </div>
  );
};

export default BookCardItemAuthor;
